import { getTranslation } from "@mivo/i18n";
import { OFFLINE_TRANSLATIONS } from "@/domains/offline/constants";
import { isClinicalAccessBlocked, type ClinicalAccessUser } from "@/domains/subscription/accountAccess";

/** Normalize axios URL (path + query, no origin). */
export function normalizeApiPath(url: string): string {
  const withoutBase = url.replace(/^https?:\/\/[^/]+/i, "");
  let path = withoutBase.startsWith("/") ? withoutBase : `/${withoutBase}`;
  if (path.startsWith("/api/")) {
path = path.slice(4);
} else if (path === "/api") {
path = "/";
}
  const q = path.indexOf("?");
  return q === -1 ? path : path.slice(0, q);
}

/** Mutations that must not run (or queue) while offline. */
export function isOfflineMutationBlocked(method: string, url: string): boolean {
  const m = method.toLowerCase();
  if (m === "get" || m === "head" || m === "options") {
return false;
}

  return true;
}

export function isOfflineClinicalMutationBlocked(user?: ClinicalAccessUser | null): boolean {
  return isClinicalAccessBlocked(user);
}

export function isCacheableGet(url: string): boolean {
  const path = normalizeApiPath(url);
  if (path === "/patients") {
return true;
}
  if (path === "/sessions") {
return true;
}
  if (path === "/auth/me") {
return true;
}
  return false;
}

export const OFFLINE_BLOCKED_MESSAGES = {
  get upload() {
    return getTranslation(OFFLINE_TRANSLATIONS.blockedUpload);
  },
  get chat() {
    return getTranslation(OFFLINE_TRANSLATIONS.blockedChat);
  },
  get newSession() {
    return getTranslation(OFFLINE_TRANSLATIONS.blockedNewSession);
  },
  get ai() {
    return getTranslation(OFFLINE_TRANSLATIONS.blockedAi);
  },
} as const;
